import { Component, xml, useState, onMounted } from "@odoo/owl";
import { ApiService } from "./services/api_service";

/**
 * Beadvány részletek komponens
 */
class RecordDetail extends Component {
    static template = xml`
        <div class="record-detail">
            <h2>Határozat Részletek</h2>
            
            <div t-if="state.loading" class="loading">
                <p>Betöltés...</p>
            </div>
            
            <div t-elif="state.error" class="error">
                <p class="text-danger">Hiba történt az adatok betöltése során.</p>
                <button class="btn btn-secondary" t-on-click="props.onBack">
                    Vissza a listához
                </button>
            </div>
            
            <div t-elif="state.record" class="decision-details">
                <!-- Dinamikus mezők megjelenítése metadata alapján -->
                <t t-foreach="getDisplayFields()" t-as="field" t-key="field">
                    <div class="decision-details-item">
                        <div class="decision-details-item-label" t-esc="getFieldLabel(field) + ':'"/>
                        <div class="decision-details-item-value" t-esc="state.record[field] ?? '-'"/>
                    </div>
                </t>
                
                <!-- Fájl letöltések megjelenítése metadata alapján -->
                <t t-if="getFileFields().length > 0">
                    <div class="decision-details-downloads">
                        <t t-foreach="getFileFields()" t-as="fileField" t-key="fileField">
                            <t t-set="files" t-value="state.record[fileField]"/>
                            <t t-if="files and files.length > 0">
                                <div class="decision-details-item">
                                    <div class="decision-details-item-label" t-esc="getFieldLabel(fileField) + ':'"/>
                                    <div class="decision-details-item-downloads">
                                        <t t-foreach="files" t-as="file" t-key="file_index">
                                            <a 
                                                t-att-href="file.url" 
                                                target="_blank" 
                                                rel="noopener noreferrer" 
                                                class="download-link"
                                            >
                                                <div class="download-item">
                                                    <div class="icon">
                                                        <i class="fontawesome-icon fa-download fas"></i>
                                                    </div>
                                                    <span class="download-label">Letöltés</span>
                                                    <t t-if="file.lang">
                                                        <span class="download-lang" t-esc="'(' + file.lang.toUpperCase() + ')'"/>
                                                    </t>
                                                </div>
                                            </a>
                                        </t>
                                    </div>
                                </div>
                            </t>
                        </t>
                    </div>
                </t>
                
                <div class="actions">
                    <button class="btn btn-primary" t-on-click="props.onBack">
                        Vissza a listához
                    </button>
                </div>
            </div>
        </div>
    `;

    setup() {
        this.apiService = new ApiService(this.env.apiUrl);

        this.state = useState({
            record: null,
            loading: false,
            error: false
        });

        onMounted(async () => {
            if (this.props.recordId) {
                await this.loadRecord(this.props.recordId);
            }
        });
    }

    async loadRecord(recordId) {
        this.state.loading = true;
        this.state.error = false;

        try {
            const data = await this.apiService.fetchRecordDetail(recordId);
            this.state.record = data;
        } catch (error) {
            console.error("Error fetching record details:", error);
            this.state.error = true;
        } finally {
            this.state.loading = false;
        }
    }

    /**
     * Metadata alapján visszaadja a megjelenítendő mezőket
     */
    getDisplayFields() {
        const recordType = this.state.record?.type.toLowerCase();
        if (!recordType || !this.props.metadata?.types?.[recordType]) {
            // Ha nincs metadata, akkor alapértelmezett mezőket jelenítünk meg
            return ['id', 'decision_number', 'subject', 'decision_date', 'institution', 'decision', 'type'];
        }
        return this.props.metadata.types[recordType].display_fields || [];
    }

    /**
     * Metadata alapján visszaadja a fájl mezőket
     */
    getFileFields() {
        const recordType = this.state.record?.type;
        if (!recordType || !this.props.metadata?.types?.[recordType]) {
            // Alapértelmezett fájl mezők ha nincs metadata
            return ['decision_file', 'report_file'];
        }
        return this.props.metadata.types[recordType].file_fields || [];
    }

    /**
     * Mezőnevek magyar fordítása
     */
    getFieldLabel(field) {
        const labels = {
            'id': 'ID',
            'decision_number': 'Határozatszám',
            'subject': 'Tárgy',
            'mab_code': 'MAB kód',
            'institution': 'Benyújtó Intézmény',
            'votes': 'Szavazatok',
            'educational_level': 'Képzési szint',
            'science': 'Tudományág',
            'decision': 'Döntés',
            'type': 'Beadvány Típusa',
            'decision_date': 'Határozathozatal dátuma',
            'decision_file': 'Határozat',
            'report_file': 'Jelentés'
        };
        return labels[field] || field;
    }
}

export default RecordDetail;
